import { render } from "./NavHeader.vue?vue&type=template&id=22cc5d28&scoped=true"
import script from "./NavHeader.vue?vue&type=script&lang=js"
export * from "./NavHeader.vue?vue&type=script&lang=js"

import "./NavHeader.vue?vue&type=style&index=0&id=22cc5d28&scoped=true&lang=css"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22cc5d28"]])

export default __exports__